import RegistrationQuizMain from "./components/RegistrationQuizMain";

export default RegistrationQuizMain;
